import { Sprite } from 'pixi.js';
import type { WinStreakRoadPopupLayout } from '../../../../layouts/winStreak/WinStreakRoadPopupLayout';
import { cropSprite } from '../../../game/views/utils/cropSprite';

export class WinStreakChestProgressBarHandler {
  private max = 0;

  private current = 0;

  private readonly maxFillPx: number;

  private readonly separators: Sprite[] = [];

  constructor(
    private readonly layout: WinStreakRoadPopupLayout,
    current: number,
    max: number,
  ) {
    this.maxFillPx = layout.progressBarFill.width;
    this.setNewProgress(current, max);
  }

  public setNewProgress(current: number, max: number): void {
    this.current = current;
    this.max = max;

    // no chest
    if (max === 0) {
      this.hide();
      return;
    }

    this.createNewSeparators();
    cropSprite(this.layout.progressBarFill, this.current / this.max, 'width');
  }

  private createNewSeparators(): void {
    if (this.layout.root.destroyed) return;
    this.separators.forEach((child) => {
      child.destroy();
    });
    this.separators.length = 0;

    const {
      layout: { progressBarFill },
    } = this;

    const distance = this.maxFillPx / this.max;
    for (let i = 1; i < this.max; i += 1) {
      this.separators.push(
        new Sprite().props({
          texture: 'WinStreak_Progress_Bar_Top_Separation',
          x: progressBarFill.x + distance * i,
          y: progressBarFill.y - 6,
          anchorX: 0.5,
          anchorY: 0,
          parent: progressBarFill.parent,
        }),
      );
    }
  }

  public hide(): void {
    const { progressBar, progressBarChest } = this.layout;

    [progressBar, progressBarChest].forEach((elem) => {
      elem.tweenTo({ alpha: 0 }, 200, 'sinIn', true);
    });
  }

  public animateChange(newCurrent: number, max: number): void {
    if (this.max !== max) return;

    this.layout.root.tweens
      .create(this)
      .to({ current: newCurrent }, 300, 'sinOut', true)
      .onUpdateCallback(() => {
        cropSprite(this.layout.progressBarFill, this.current / this.max, 'width');
      });
  }
}
